// @flow
import React from 'react';

export default ({ className = '', ...props }) => (
  <i className={`${className} fa fa-angle-double-left`} {...props} />
);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/theme/icons/DoubleArrowLeft.js